import {
  KEYWORDS_DETAILS_SECTION_I18N_KEYS
} from '../../../../../../features/topics/components/edit-topic/constants/i18n/KeywordsDetailsSectioni18nConstants';

export const KEYWORDS_DETAILS_SECTION_I18N_EN = {
  [KEYWORDS_DETAILS_SECTION_I18N_KEYS.keywords_details_section_title]:      "Keyword Filtering for Social Media Data",
  [KEYWORDS_DETAILS_SECTION_I18N_KEYS.no_keywords_for_topic_message]:       "No keyword filters have been added. Click on the edit button to add keyword filters and extract social media data.",
  [KEYWORDS_DETAILS_SECTION_I18N_KEYS.any_of_these_keywords]:               "Any of these keywords",
  [KEYWORDS_DETAILS_SECTION_I18N_KEYS.and_any_of_these_keywords]:           "And any of these keywords",
  [KEYWORDS_DETAILS_SECTION_I18N_KEYS.none_of_these_keywords]:              "None of these keywords",
  [KEYWORDS_DETAILS_SECTION_I18N_KEYS.no_keywords_in_section_default_text]: "None",
  [KEYWORDS_DETAILS_SECTION_I18N_KEYS.earliest_historical_data_date]:       "Earliest Historical Data Date",
};


// WEBPACK FOOTER //
// ./src/locales/en/features/topics/components/edit-topic/keywords_details_section.i18n.en.js